<template>
  <div class="form-template">
    <div class="card-header">
      <span>{{ title }}</span>
    </div>
    <el-form ref="productForm" :model="formData" :rules="rules" label-width="120px" label-position="left" size="medium"
      class="product-form">
      <slot name="body">
      </slot>
    </el-form>
  </div>

</template>
<script>
export default {
  name: 'BaseInfo',
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default: '基本信息'
    },
    rules: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.card-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  height: 50px;
}
.form-template{
  width: 100%;
  height: auto;
  border-radius: 8px;
  background-color:#fff ;
  padding: 10px 20px;
  margin-bottom: 10px;
}
.el-input {
  width: 60%;
}
</style>